// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3-31t","dragIcon":"Choice_dragIcon__1rcXx","left":"Choice_left__1EQ7S","input":"Choice_input__11oVZ"};